import { generateXIQSignature, getCurrentTimeStamp } from "utils/header-utils";
import wretch from "wretch";
import {
  ClassmonEventType,
  ITrackEventPayload,
  ITrackEventResponse
} from "./classmonService.types";

const BASE_URL = process.env.NEXT_PUBLIC_CLASSMON_URL;

export const trackClassmonEvent = async (
  event: ClassmonEventType,
  userId: string,
  liveClassId: string | null
): Promise<ITrackEventResponse> => {
  const timestamp = getCurrentTimeStamp();
  const platform = "desktopWeb";
  const payload: ITrackEventPayload = {
    event,
    user_id: userId,
    live_class_id: liveClassId,
    timestamp,
    metadata: { platform }
  };
  const user = JSON.stringify(payload);
  const signature = generateXIQSignature(platform, timestamp, user);
  return wretch(`${BASE_URL}/api/track-event`)
    .headers({
      "Content-Type": "application/json",
      "x-iq-platform": platform,
      "x-iq-timestamp": timestamp,
      "x-iq-signature": signature
    })
    .post(payload)
    .json();
};
